const rules = {
    required: value => {
       return (!!value && (value.toString().trim().length > 0 || (Array.isArray(value) && value.length > 0))) || "Required";
    },
    requiredNumber: value => {
        return !!value || "Required";
    },
    requiredObject: value => {
        return value != null || "Required";
    },
    requiredNonEmptyArray: value => {
        return (value != null && value.length > 0) || "Required";
    },
    requiredDate: value => {
        return value != null || "Required";
    },
    selectRequired: value => {
        return (value != null && value > 0) || "Required";
    },
    From0To100: value => {
        return (!value || (parseFloat(value) >= 0 && parseFloat(value) <= 100)) || "Must be a positive number from 0 to 100";
    },
    From1To100: value => {
        return (!value || (parseFloat(value) > 0 && parseFloat(value) <= 100)) || "Must be a positive number from 1 to 100";
    },
    From0To9999: value => {
        return (parseFloat(value) >= 0 && parseFloat(value) <= 9999) || "Must be a positive number from 0 to 9,999";
    },
    From10To15: value => {
        return (parseFloat(value) >= 10 && parseFloat(value) <= 15) || "Must be a number from 10 to 15";
    },
    fromAToB: (a, b) => {
        return value => {
            return (parseFloat(value) >= a && parseFloat(value) <= b) || `Must be a positive number from ${a} to ${b}`;
        }
    },
    integerOnly: value => {
        return (!value || Number.isInteger(parseFloat(value))) || "Please provide an integer value."
    },
    isNumber: value => {
        return (!value || !isNaN(value)) || "Please provide number value."
    },
    maxFifteenCharacters: value => {
        return (value == null || (value != null && value.length <=15)) || "Maximum 15 characters";
    },
    maxthirtyCharacters: value => {
        return (value != null && value.length <=30) || "Maximum 30 characters";
    },    
    maxfiftyCharacters: value => {
        return (value != null && value.length <=50) || "Maximum 50 characters";
    },    
    maxOneHundredCharacters: value => {
        return (value == null || (value != null && value.length <=100)) || "Maximum 100 characters";
    },
    maxTwoHundredCharacters: value => {
        return (value == null || (value != null && value.length <=200)) || "Maximum 200 characters";
    },
    maxFiveHundredCharacters: value => {
        return (value == null || (value != null && value.length <=500)) || "Maximum 500 characters";
    },
    maxOneThousandCharacters: value => {
        return (value == null || (value != null && value.length <=1000)) || "Maximum 1000 characters";
    },
    maxFiveThousandCharacters: value => {
        return (value == null || (value != null && value.length <=5000)) || "Maximum 5000 characters";
    },
    number({ min, max, decimalPlaces }){
        if(decimalPlaces == null){
            decimalPlaces = 0;
        }

        return value => {
            // Mandatory/optional can be handled by a different validation rule
            if(value == null){
                return false;
            }

            if(isNaN(value)){
                return "Invalid number value";
            }

            if(value.toString().indexOf(".") >= 0){
                let split = value.toString().split(".");
                let decimalPart = split[1];

                if(decimalPart.length > decimalPlaces){
                    return `Maximum ${decimalPlaces} decimal places`;
                }
            }

            let numericValue = parseFloat(value);
            if(min != null && numericValue < min){
                return `Must be above ${min}`;
            }

            if(max != null && numericValue > max){
                return `Must be below ${max}`;
            }

            return false;
        }
    }
}

export default {
    rules
}